import React from 'react';
import { useTranslation } from 'react-i18next';

import { DialogMessageContents, ModalDialog } from '@/components/Elements';

/**
 * プロパティ
 */
type Props = {
  // ダイアログ表示/非表示(true=表示)
  isOpen: boolean;
  // OKボタンクリック時の処理
  onClickOKButton: () => void;
};

/**
 * 共有URL無効お知らせダイアログ コンポーネント
 */
export const ShareUrlInvalidDialog = React.memo(
  ({ isOpen, onClickOKButton }: Props) => {
    const { t } = useTranslation();

    return (
      <ModalDialog
        isOpen={isOpen}
        isHiddenCloseButton
        title={t('shareUrlInvalidDialog.共有URLが無効になりました').toString()}
        buttons={[
          { label: 'OK', onClick: onClickOKButton, gtmClassTag: 'dialog-18' },
        ]}
      >
        <DialogMessageContents>
          {t('shareUrlInvalidDialog.主催者により共有が終了されました。')}
        </DialogMessageContents>
      </ModalDialog>
    );
  },
);
